import { createSelector } from 'reselect'
import { PeopleMembersState } from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { RootState } from 'src/redux/createRootReducer'
import { selectMembersListModelsFromState } from 'src/redux/selectors/data/members.selectors'

export const selectPeopleMembers = (state: RootState): PeopleMembersState =>
  state.app.people.peopleMembers

export const selectPeopleMembersLoadingFromState = (
  state: RootState,
): boolean => state.app.people.peopleMembers.loading

export const selectPeopleMembersRemovingFromState = (
  state: RootState,
): boolean => state.app.people.peopleMembers.removing

export const selectPeopleMembersRemoveFailureFromState = (
  state: RootState,
): string | undefined =>
  state.app.people.peopleMembers.removeFailureTopLevelError

export const selectNumberOfMembersFromState = (state: RootState): number =>
  state.app.people.peopleMembers.totalItems || 0

const selectUniquePeopleMemberIds = createSelector(
  [selectPeopleMembers],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)

export const selectUniquePeopleListModels = createSelector(
  [selectUniquePeopleMemberIds, selectMembersListModelsFromState],
  (ids, members) => {
    return ids.map((id) => members[id]).filter((id) => id !== undefined)
  },
)

export const selectFilteredPeopleMembers = createSelector(
  [selectUniquePeopleListModels],
  (people) => people.filter(() => true),
)
